export default "__VITE_ASSET__07fce8ad__"